import Swiper from 'swiper/dist/js/swiper.js';

export default class Slider {
  slider;
  type;
  arrows;
  progress;
  slidesPerView;

  swiper;

  constructor(slider) {
    this.slider = slider;
    this.type = this.slider.getAttribute('data-type');
    this.arrows = this.slider.getAttribute('data-arrows') === '1' ? true: false;
    this.progress =  this.slider.getAttribute('data-progress') === '1' ? true: false;
    this.slidesPerView = this.slider.getAttribute('data-slides-per-view');

    let pagination = this.progress ? {
        el: '.swiper-pagination'
      } : false;

    this.swiper = new Swiper(this.slider, {
      slidesPerView: this.type == 'multi' ? this.slidesPerView : 1,
      pagination: pagination
    });
  }
}


// WEBPACK FOOTER //
// ./ui/assets/js/Slider/Slider.js